import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export const getVendorShipmentConfigAPI = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.PovAPI}/GetVendorFieldsVisiblity`,
  });
};

export type VendorShipmentConfigResponse = {
  customerKey: number;
  columnName: string;
  moduleName: string;
  isVisible: 0 | 1;
}[];

export const fetchVendorShipmentConfig = async (): Promise<VendorShipmentConfigResponse> => {
  const response: AxiosResponse<VendorShipmentConfigResponse> = await getVendorShipmentConfigAPI();
  return response.data;
};
